export function reloadPageWithoutCache() {
  const url = new URL(window.location.href)
  url.searchParams.set('__time__', Date.now().toString())
  window.location.replace(url.href)
}
